import React from 'react';
import * as PropTypes from 'prop-types';
import { constants } from 'cv-react-core';
import { VerticalForm as VerticalFormBase } from 'cv-library-react-web';

import getStyles from './VerticalForm.styles';

const VerticalForm = (props) => {
    const {
        formElements,
        onResizeStop,
        ...rest
    } = props;
    const styles = getStyles();
    const { ui } = constants;

    const handleResizeStop = (e, dir, ref) => {
        const viewId = ref.getAttribute('viewid');
        const {
            style: {
                width,
                height,
            },
        } = ref;
        onResizeStop(viewId, width, height);
    };

    return (
        <VerticalFormBase
            contextStyles={ styles }
            formElements={ formElements }
            onResizeStop={ handleResizeStop }
            scrollIdentifier={ ui.SCROLL_CONTAINER }
            { ...rest } />
    );
};

VerticalForm.propTypes = {
    formElements: PropTypes.arrayOf(PropTypes.element),
    onResizeStop: PropTypes.func,
};

VerticalForm.defaultProps = {
    formElements: [],
};

export default VerticalForm;
